import profile1 from '../../../assets/images/profile-1.png'
import profile2 from '../../../assets/images/profile-2.png'
import profile3 from '../../../assets/images/profile-3.png'
import profile4 from '../../../assets/images/profile-4.png'
import profile5 from '../../../assets/images/profile-5.png'
import est from '../../../assets/svg/est.svg'
import ger from '../../../assets/svg/ger.svg'
import usa from '../../../assets/svg/usa.svg'
import dota from '../../../assets/images/dota2.jpg'
import cs from '../../../assets/images/cs.jpg'

export const players = [
  {
    id: 0,
    player: 'Dima',
    img: profile4,
  },
  {
    id: 1,
    player: 'Boris',
    img: profile2,
  },
  {
    id: 2,
    player: 'Leopold',
    img: profile1,
  },
  {
    id: 3,
    player: 'Peter',
    img: profile5,
  },
  {
    id: 4,
    player: 'George',
    img: profile2,
  },
  {
    id: 5,
    player: 'Adolf',
    img: profile5,
  },
  {
    id: 6,
    player: 'Pedro',
    img: profile1,
  },
  {
    id: 7,
    player: 'Hose',
    img: profile3,
  },
  {
    id: 8,
    player: 'Jime',
    img: profile5,
  },
  {
    id: 9,
    player: 'Dariel',
    img: profile1,
  },
  {
    id: 10,
    player: 'Romeo',
    img: profile4,
  },
  {
    id: 11,
    player: 'Vlad',
    img: profile1,
  },
]

export const data = [
  {
    id: 0,
    country: 'Estonia',
    img: est,
  },
  {
    id: 1,
    country: 'Germany',
    img: ger,
  },
  {
    id: 2,
    country: 'USA',
    img: usa,
  },
]
export const languageList = [
  {
    id: 0,
    language: 'Estonian',
    img: est,
  },
  {
    id: 1,
    language: 'Germany',
    img: ger,
  },
  {
    id: 2,
    language: 'English',
    img: usa,
  },
]
export const games = [
  {
    id: 0,
    game: 'Dota 2',
    img: dota,
  },
  {
    id: 1,
    game: 'CS GO',
    img: dota,
  },
  {
    id: 2,
    game: 'Lineage',
    img: cs,
  },
  {
    id: 3,
    game: 'PUBG',
    img: cs,
  },
  {
    id: 4,
    game: 'Garry Potter',
    img: cs,
  },
  {
    id: 5,
    game: 'Half Life',
    img: cs,
  },
  {
    id: 6,
    game: 'Dota 3',
    img: dota,
  },
  {
    id: 7,
    game: 'CS GO 2',
    img: dota,
  },
  {
    id: 8,
    game: 'Lineage 2',
    img: cs,
  },
  {
    id: 9,
    game: 'PUBG 2',
    img: cs,
  },
  {
    id: 10,
    game: 'Garry Potter 2',
    img: cs,
  },
  {
    id: 11,
    game: 'Half Life 2',
    img: cs,
  },
]
